import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { Toaster } from 'sonner';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { AnalyticsProvider } from './contexts/AnalyticsContext';
import { AnalyticsErrorBoundary } from './components/AnalyticsErrorBoundary';
import { IdentityLinker } from './components/IdentityLinker';
import { queryClient } from './lib/queryClient';
import App from './App';
import './index.css';

const toastStyle = {
  style: {
    fontFamily: 'inherit',
  },
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <ThemeProvider>
          <AuthProvider>
            <AnalyticsProvider>
              <IdentityLinker />
              <AnalyticsErrorBoundary>
                <App />
              </AnalyticsErrorBoundary>
              <Toaster
                position="top-center"
                richColors
                closeButton
                toastOptions={toastStyle}
              />
            </AnalyticsProvider>
          </AuthProvider>
        </ThemeProvider>
      </BrowserRouter>
      {import.meta.env.DEV && <ReactQueryDevtools initialIsOpen={false} />}
    </QueryClientProvider>
  </React.StrictMode>
);
